import React from "react";

const CEREditSection = ({ children }) => {
  return <div className="custom-card my-3">{children}</div>;
};

export default CEREditSection;
